import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../../services';
import {ErrorModel, ResultModel} from '../../../../models';
import {LoggerService} from '../../../../services';
import { DashboardConsultantProduction } from '../../../../models/dashboard/dashboardConsultantProduction';
const FUNCTION_CODE = 'GET_ALL_DASHBOARD_CONSULTANT_WORKLOAD';

export async function getAllProductions(userData: Record<string, any>, params: string) {
    try {
        LoggerService.logInfo('Action - getAllDashboardConsultantProduction - Start');

        const getAllDashboardConsultantProduction =
            await DashboardService.ConsultantService.ProductionService.getAllProductions(userData, params);

        LoggerService.logInfo('Action - getAllDashboardConsultantProduction - End - Success');

        return ResultModel.newSuccessResultTyped<DashboardConsultantProduction>(getAllDashboardConsultantProduction);
    }
    catch (error) {
        LoggerService.logInfo('Action - getAllDashboardConsultantProduction - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
